import React, { createRef, useEffect, useState } from 'react';
import { CustomInput, SectionLabel, ToggleButton } from '../../../components/common';
import AccordionTile from '../Accordion';
import { Package, useUpdatePackage } from '../../../hooks/useClients';

interface PromotionProps {
  packageData: Package;
  setSaveDataModal: (data: boolean) => void;
}

const Promotion: React.FunctionComponent<PromotionProps> = ({ packageData }): JSX.Element => {
  const { updatePackage } = useUpdatePackage(packageData.client_id!, packageData.id!);

  const [promo, setpromo] = useState<boolean>(false);
  const [promoURL, setpromoURL] = useState<string>('');
  const [promoLabel, setpromoLabel] = useState<string>('');
  const [image, setimgPreview] = useState<string | null>(null);
  const [home, setHome] = useState<boolean>(false);
  const [activeCall, setActiveCall] = useState<boolean>(false);
  const [preCall, setPreCall] = useState<boolean>(false);
  const [clientTile, setclientTile] = useState<boolean>(false);
  const [preloadedImage, setpreloadedImage] = useState<boolean>(false);
  const [enableSaveOption, setEnableSaveOption] = useState<boolean>(false);

  const [Style] = useState([
    { label: 'Select', value: '' },
    { label: 'Image', value: 'Image' },
  ]);
  const fileInput: any = createRef();

  const onFileChange = async (event: any) => {
    try {
      //

      if (event.target.files && event.target.files[0]) {
        // setimage(event.target.files[0]);
        let reader = new FileReader();
        reader.onload = (e: any) => {
          setimgPreview(e.target.result);
          setpreloadedImage(false);
          setEnableSaveOption(true);
        };
        reader.readAsDataURL(event.target.files[0]);
      }

      // Update the state
    } catch (error) {
      console.error('err--', error);
    }
  };

  const handleImageInput = (e: any) => {
    fileInput.current.click();
  };

  useEffect(() => {
    if (packageData) {
      const branding = packageData?.branding_configuration;
      if (branding) {
        setpromo(branding?.enabled);
        setpromoURL(branding.url);
        setpromoLabel(branding.button_label);
        const buttonlabels = branding.placements ? branding.placements : [];
        setActiveCall(buttonlabels.includes('active_call'));
        setHome(buttonlabels.includes('home'));
        setclientTile(buttonlabels.includes('client_tile'));
        setPreCall(buttonlabels.includes('pre_call'));
        if (branding.image_url) {
          setimgPreview(branding.image_url);
          setpreloadedImage(true);
        }
      } else {
        setpromoLabel('VISIT PARTNER');
      }
      preloadedImage && setEnableSaveOption(false);
    }
  }, [packageData]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSave = () => {
    const placements = [];

    if (activeCall) {
      placements.push('active_call');
    }
    if (home) {
      placements.push('home');
    }
    if (clientTile) {
      placements.push('client_tile');
    }
    if (preCall) {
      placements.push('pre_call');
    }

    const payload: Partial<Package> = {
      branding_configuration: {
        button_label: promoLabel ? promoLabel : 'VISIT PARTNER',
        enabled: promo,
        ...(preloadedImage ? {} : { image_url: image }),
        placements: placements,
        type: 'image',
        url: promoURL,
        video_url: undefined,
      },
    };

    if (packageData.id) {
      updatePackage.mutate(payload);
    }
  };

  return (
    <AccordionTile
      setStatus={(data: boolean) => {
        !enableSaveOption && setEnableSaveOption(true);
        setpromo(data);
      }}
      Label={'PROMO '}
      buttonText={'SAVE'}
      status={promo}
      id={'promo'}
      initialstatus={true}
      disableButton={enableSaveOption}
      onButtonClick={() => {
        if (enableSaveOption) onSave();
      }}
      InnerComponent={
        <div className="my-10 flex justify-evenly gap-7">
          <div className="w-full">
            <div className="py-4">
              <CustomInput
                inputType={'text'}
                value={promoURL}
                setValue={setpromoURL}
                Label={'Promo URL'}
                dataTestId="promo-url"
              />
            </div>
            <div className="py-4">
              <CustomInput
                inputType={'text'}
                value={promoLabel}
                setValue={(data) => {
                  !enableSaveOption && setEnableSaveOption(true);
                  setpromoLabel(data);
                }}
                Label={'Button Label'}
                dataTestId="button-label"
              />
            </div>

            <SectionLabel Label="Promo Placements" />
            <div className="flex w-full justify-between">
              <div className="flex w-full justify-between">
                <div className="flex w-full justify-between py-4">
                  <div className="w-full">
                    <p className="text-blue-dark py-2 text-sm font-medium">Home</p>
                  </div>
                  <div className="w-full">
                    <ToggleButton
                      status={home}
                      setStatus={(data) => {
                        !enableSaveOption && setEnableSaveOption(true);
                        setHome(data);
                      }}
                      initialstatus={true}
                      id={'home'}
                    />
                  </div>
                </div>
                <div className="flex w-full justify-between py-4">
                  <div className="w-full">
                    <p className="text-blue-dark py-2 text-sm font-medium">Active-Call</p>
                  </div>
                  <div className="w-full">
                    <ToggleButton
                      status={activeCall}
                      setStatus={(data) => {
                        !enableSaveOption && setEnableSaveOption(true);
                        setActiveCall(data);
                      }}
                      initialstatus={true}
                      id={'activeCall'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex w-full justify-between">
              <div className="flex w-full justify-between">
                <div className="flex w-full justify-between py-4">
                  <div className="w-full">
                    <p className="text-blue-dark py-2 text-sm font-medium">Pre-Call</p>
                  </div>
                  <div className="w-full">
                    <ToggleButton
                      status={preCall}
                      setStatus={(data) => {
                        !enableSaveOption && setEnableSaveOption(true);
                        setPreCall(data);
                      }}
                      initialstatus={true}
                      id={'preCall'}
                    />
                  </div>
                </div>
                <div className="flex w-full justify-between py-4">
                  <div className="w-full">
                    <p className="text-blue-dark py-2 text-sm font-medium">Client Tile Override</p>
                  </div>
                  <div className="w-full">
                    <ToggleButton
                      status={clientTile}
                      setStatus={(data) => {
                        !enableSaveOption && setEnableSaveOption(true);
                        setclientTile(data);
                      }}
                      initialstatus={true}
                      id={'clientTile'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full">
            <div>
              <div className="py-4">
                <div className="flex w-full justify-between">
                  <div className="w-full">
                    <div className="w-full">
                      <div className="text-blue-dark block pb-2 text-sm font-medium leading-4">Style</div>
                      <div className="relative mb-2 inline-flex w-full">
                        <svg
                          className="pointer-events-none absolute right-0 top-0 m-4 h-2 w-2"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 412 232"
                        >
                          <path
                            d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                            fill="#648299"
                            fill-rule="nonzero"
                          />
                        </svg>
                        <select className="text-gray-dark bg-gray-background-light h-full w-full appearance-none rounded-md px-3 py-2 text-sm font-extrabold leading-4 focus:ring-transparent">
                          {Style.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="py-4">
              <SectionLabel Label={'Promo Image'} />
            </div>
            <div className="flex h-64 w-full items-center justify-center rounded-sm bg-gray-200">
              {image ? (
                <>
                  <img className="h-full w-full" src={image} alt="clientImage" />
                </>
              ) : (
                <div>
                  <button
                    className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-3xl"
                    onClick={handleImageInput}
                    data-testid="add-promo-image"
                  >
                    +
                  </button>
                  <input ref={fileInput} id="file-upload" type="file" className="hidden" onChange={onFileChange} />
                </div>
              )}
            </div>
            {image && (
              <button
                className="stacked-bar-blue-400 my-2 w-full rounded-sm p-4 text-center text-sm text-white"
                onClick={() => {
                  !enableSaveOption && setEnableSaveOption(true);
                  setimgPreview(null);
                  setpreloadedImage(false);
                }}
                data-testid="remove-promo-image"
              >
                REMOVE
              </button>
            )}
          </div>
        </div>
      }
    />
  );
};

export default Promotion;
